import { Component } from '@angular/core';
import * as moment from 'moment';
import { BookingCredentials } from 'src/app/booking-credentials';
import { UserData } from 'src/app/Models/employee-and-user-data';
import { cruiseContentEvtCodeFromSession } from 'src/app/utils/voyage-pms-code';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { LoginService } from 'src/app/Services/login.service';
import { readStoredClientIp } from 'src/app/utils/client-ip-storage';
import { ShoreexcursionsService } from 'src/app/Services/shoreexcursions.service';
import { TripContextService } from 'src/app/Services/trip-context.service';
import { isShoreExcursionModificationLocked } from 'src/app/utils/shore-excursions-access';

@Component({
  selector: 'app-shore-excursion-signup',
  templateUrl: './shore-excursion-signup.component.html',
  styleUrls: ['./shore-excursion-signup.component.css'],
  providers: [ShoreexcursionsService],
})
export class ShoreExcursionSignupComponent {
  userdata?: UserData;
  rebcode: string | undefined;
  OBPortalSvcURL = '';
  shorexUrl = '';
  day1: boolean = false;

  ShorexLinkInfo: string = '';
  ShorexLinkdata: any;
  RecordAccessData: any;
  logincredentials = new BookingCredentials();

  /** Within N days before sail: defer to in-portal excursions (not personalization link). */
  excursionsModificationLocked = false;

  /**
   * 14-day preview guests keep the PassengerExcursions signup link even when modification
   * lock would otherwise hide it.
   */
  useExternalSignupLink = false;

  constructor(
    private appConfigService: AppConfigService,
    private loginservice: LoginService,
    private ShoreexcursionsService: ShoreexcursionsService,
    private tripContextService: TripContextService,
  ) {}

  ngOnInit() {
    this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
    this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
    this.userdata?.pckgBeg;
    var test = moment();

    let excursionend = moment();
    const voyageCode = cruiseContentEvtCodeFromSession(this.userdata);
    if (voyageCode.length >= 9) {
      excursionend = moment(
        '20' + voyageCode.substring(3, 9) + ' 17:00:00',
        'YYYYMMDD hh:mm:dd'
      );
    }

    this.rebcode = this.userdata?.rebcode;
    this.shorexUrl = this.appConfigService.shorexURL;
    this.excursionsModificationLocked = isShoreExcursionModificationLocked(
      this.userdata,
    );
    const phase = this.tripContextService.resolve(this.userdata).phase;
    this.useExternalSignupLink =
      phase === 'preview' || !this.excursionsModificationLocked;
    if (this.useExternalSignupLink) {
      this.getShorexLink();
    }
    if (moment().isBefore(excursionend)) {
      this.day1 = true;
    }
  }
  getShorexLink() {
    this.ShorexLinkdata = this.ShoreexcursionsService.getBookingHash(
      this.rebcode
    ).subscribe((ShorexLinkdata) => this.setShorexLink(ShorexLinkdata));
  }

  setShorexLink(resdata: any) {
    this.ShorexLinkdata = resdata;
    if (this.ShorexLinkdata.GetHashFromBookingCode.Result.Status == 'A') {
      this.ShorexLinkInfo = this.ShorexLinkdata.GetHashFromBookingCode.Hash;
    }
  }
  recordExcursionLinkAccess(): void {

    const ip = readStoredClientIp();

    // IF WE DON'T HAVE THE IP ADDRESS THEN WE WANT TO EXIT THIS FUNCTION EARLY
    // WE DON'T WANT TO WAIT FOR THIS API REQUEST TO FAIL...
    if (ip == undefined || ip == null || ip == '') {
      console.error("Unable to extract end users ip address.");
      return;
    }

    this.RecordAccessData = this.loginservice
      .RecordAccess(this.rebcode, true, ip, 'Guest', 'excursions')
      .subscribe((recordAccessdata) => this.setRecordAccess(recordAccessdata));
  }

  setRecordAccess(resdata: any) {
    this.RecordAccessData = resdata;
    if (this.RecordAccessData.ResRecordAccess.Result.Status == 'A') {
    }
  }
}
